import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.02388 16.4307L6.38721 13.8588C6.1949 13.2746 6.09091 12.6498 6.09091 11.9998C6.09091 11.3498 6.1949 10.7249 6.38721 10.1408L3.02388 7.56885C2.36791 8.9025 2 10.4061 2 11.9998C2 13.5935 2.36791 15.0971 3.02388 16.4307Z",
      fill: "#FBBC05"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.38725 10.141C7.16325 7.78407 9.3773 6.09091 12 6.09091C13.4091 6.09091 14.6819 6.59091 15.6819 7.40909L18.591 4.5C16.8182 2.95455 14.5455 2 12 2C8.04828 2 4.6505 4.2621 3.02393 7.56906L6.38725 10.141Z",
      fill: "#EA4335"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.9999 21.9999C8.04707 21.9999 4.6485 19.7366 3.02246 16.4281L6.38442 13.8506C7.15795 16.2119 9.37411 17.909 11.9999 17.909C13.2848 17.909 14.4233 17.6064 15.3249 17.0374L18.5179 19.5094C16.77 21.1346 14.439 21.9999 11.9999 21.9999Z",
      fill: "#34A853"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 10.1816H21.3182C21.4545 10.7725 21.5455 11.4089 21.5455 11.9998C21.5455 15.2591 20.3531 17.803 18.5179 19.5093L15.325 17.0373C16.369 16.3785 17.0953 15.3624 17.3636 14.0453H12V10.1816Z",
      fill: "#4285F4"
    }, null, -1)
  ])))
}
export default { render: render }